import AccountAdminUser from "./AccountAdminUser-container";

/**
 * Export the top level component AccountAdminUser-container
 *
 * @version 0.0.1
 * @author Steve Hunley
 *
 */
export default AccountAdminUser;
